function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeartOutlined = function SvgHeartOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.833,
    d: "m11.766 21.513.233.156.232-.156c4.485-3.017 7.09-5.894 8.365-8.456 1.28-2.571 1.22-4.831.357-6.547-1.64-3.263-6.152-4.414-8.954-1.89-2.802-2.524-7.314-1.372-8.955 1.89-.863 1.716-.923 3.977.357 6.548 1.275 2.561 3.88 5.438 8.365 8.455Z",
    style: {
      stroke: "currentColor"
    }
  }));
};
export default SvgHeartOutlined;